import { Platform } from '@/core/Platform';
import { StyleSheet } from '@/core/StyleSheet';

const MIN_HEIGHT = 55;

export default {
	default: StyleSheet.create({
		item: {
			minHeight: MIN_HEIGHT,
			flexDirection: 'row',
		},
		icon: {
			height: MIN_HEIGHT,
			justifyContent: 'center',
		},
		iconMain: {
			color: '$textColor',
			paddingRight: 14,
			width: 36,
		},
		wrapper: {
			flex: 1,
		},
		wrapperBorder: {
			borderBottomColor: '$inputBorderColor',
			borderBottomWidth: 1,
			...Platform.select({
				web: {
					borderBottomStyle: 'solid',
				},
			}),
		},
		header: {
			flexDirection: 'row',
			flex: 1,
			...Platform.select({
				web: {
					padding: '5px 0',
				},
			}),
		},
		content: {
			flexDirection: 'row',
			flex: 1,
		},
		side: {
			alignItems: 'center',
			flex: 1,
			flexDirection: 'row',
			maxWidth: '50%',
		},
		label: {
			height: MIN_HEIGHT,
		},
		activityIndicator: {
			alignItems: 'flex-end',
			width: '100%',
		},
		value: {
			color: '$inputBorderColor__Focused',
			fontSize: 16,
			textAlign: 'right',
			paddingRight: 5,
			width: '100%',
		},
		placeholder: {
			color: '$inputPlaceholderColor',
		},
	}),
	default__isDisabled: StyleSheet.create({
		icon: {
			color: '$colorDisabled',
		},
		label: {
			color: '$colorDisabled',
		},
		placeholder: {
			color: '$colorDisabled',
		},
	}),
};
